import { render, staticRenderFns } from "./Highlightable.vue?vue&type=template&id=0ffbe8e2&scoped=true&"
import script from "./Highlightable.vue?vue&type=script&lang=js&"
export * from "./Highlightable.vue?vue&type=script&lang=js&"
import style0 from "./Highlightable.vue?vue&type=style&index=0&id=0ffbe8e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffbe8e2",
  null
  
)

export default component.exports